import { Box } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { EmtTypography, EmtIcon, EmtModal, EmtButton } from 'emt-components-v2'
import { useCart } from '@/hooks'

// API
import { UserServiceHelper } from '@/modules/User'

// Store
import { useEMTDispatch } from '@/store'

interface DeleteAnimalModalProps {
  button?: boolean
  open: boolean
  setOpen: (open: boolean) => void
  color?: string
  uuid: string
}

const DeleteAnimalModal: React.FC<DeleteAnimalModalProps> = ({ button, open, setOpen, color = 'purple', uuid }) => {
  const { t } = useTranslation('common')
  const { t: tp } = useTranslation('petsitter')
  const dispatch = useEMTDispatch()
  const { updateCart, animals: cartAnimals } = useCart()

  /**
   * Delete an existing pet.
   */
  const deleteAnimal = async (uuid: string) => {
    try {
      await UserServiceHelper.dispatchDeleteAnimalAsync(dispatch)(uuid)
      const filteredAnimals = cartAnimals.filter((animal) => animal !== uuid)

      await updateCart({ animals: filteredAnimals })
    } catch (err) {
      console.error('Failed to delete animal:', err)
    } finally {
      setOpen(false)
    }
  }

  return (
    <EmtModal
      open={open}
      onClose={() => setOpen(false)}
      sx={{ '& .inner-box': { width: '463px', maxWidth: '90vw' }, '& .children-box': { padding: '32px' } }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          textAlign: 'center',
        }}
      >
        <EmtIcon
          className="emt-exclamation-circle"
          size="large"
          sx={{
            fontSize: 40,
            color: '#D2D1D4',
          }}
        />
        <EmtTypography variant="h4" fontWeight={800}>
          {tp('animalBox.deleteAnimalModalTitle')}
        </EmtTypography>
        <EmtTypography variant="body1">{tp('animalBox.deleteAnimalModalSubTitle')}</EmtTypography>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            justifyContent: 'center',
          }}
        >
          {button && (
            <EmtButton fullWidth variant="contained" color={color} onClick={() => deleteAnimal(uuid)}>
              {t('confirm')}
            </EmtButton>
          )}
          <EmtTypography
            variant="body2"
            color={`${color}.main`}
            fontWeight="700"
            sx={{ cursor: 'pointer' }}
            onClick={() => setOpen(false)}
          >
            {t('back')}
          </EmtTypography>
        </Box>
      </Box>
    </EmtModal>
  )
}

export default DeleteAnimalModal
